'use strict';
/**
 * @ngdoc function
 * @name scrapQApp.controller:AgentSlotCtrl
 * @description
 * # AgentSlotCtrl
 * Controller of the scrapQApp
 */
angular.module('scrapQcrmApp')
    .controller('AgentSlotCtrl', function($scope, tableState, $rootScope, $global, ngToast, agentAppointments, $uibModal, $window, growl, $log, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, $moment, $q, slotList) {
        
        $scope.transactionChange = function() {
            $scope.vm.params.page = -1;
            $scope.vm.params.date = $moment($scope.dateInput).format('DD-MMM-YYYY');

            var params = {}
            params.page = -1;
            params.date = $scope.dateInput;
            params.city= "Hyderabad";
        };

        $scope.$watch('dateInput', function(newDate) {
            $scope.transactionChange();
        }, false);

        // the date box gives a moment, the URL and the arrows a "DD-MMM-YYYY" text
        function dayOf(v) {
            if (v && v.startDate) {
                v = v.startDate;
            }
            return moment.isMoment(v) ? v.clone() : moment(v, 'DD-MMM-YYYY');
        }

        // the watch on dateInput loads the new day
        $scope.nextDate = function() {
            $scope.dateInput = dayOf($scope.dateInput).add(1, "days").format('DD-MMM-YYYY');
        }
        $scope.previousDate = function() {
            $scope.dateInput = dayOf($scope.dateInput).subtract(1, "days").format('DD-MMM-YYYY');
        }

        $scope.dateInput = $moment().format('DD-MMM-YYYY');

        // the day is kept in the URL, so Back / refresh show the same list
        tableState.page($scope, 'sd', { controls: { d: { model: 'dateInput', type: 'day' } } });
        $scope.date = {
            startDate: $scope.dateInput,
            endDate: $scope.dateInput
        };
        $scope.opts = {
            format: "DD-MMM-YYYY",
            singleDatePicker: true
        };

        $scope.vm = {
            params :{}
        };

        // one column per time slot of the slot list (plus "Other" for bookings without a valid slot), one row per agent
        var slotDefsPromise = slotList.load().catch(function() { return null; });
        var requestId = 0;
        $scope.isCountAvailable = true;
        $scope.getAppointmentsForAgents = function() {
            var mine = ++requestId;
            $q.all([agentAppointments.agentAppointmentsPerSlot(dayOf($scope.dateInput).format('DD-MMM-YYYY')), slotDefsPromise]).then(function(both) {
                if (mine !== requestId) {
                    return;
                }
                var res = both[0], rows = (res && res.status == "SUCCESS" && res.data && res.data.appointments || []).filter(Boolean);
                if (!rows.length) {
                    $scope.isCountAvailable = false;
                    return;
                }
                var ids = rows.map(function(r) { return slotList.toId(r.preferredslot); });
                var layout = slotList.layout(both[1], ids);
                var agents = [], byName = {};
                rows.forEach(function(r, i) {
                    var name = r.name || 'Not assigned';
                    if (!byName[name]) {
                        byName[name] = { agentName: name, counts: {}, total: 0 };
                        agents.push(byName[name]);
                    }
                    var key = layout.keyFor(ids[i]), n = Number(r.agentSlotCount) || 0;
                    byName[name].counts[key] = (byName[name].counts[key] || 0) + n;
                    byName[name].total += n;
                });
                $scope.slotCols = layout.cols;
                $scope.slotCount = agents;
                $scope.isCountAvailable = true;
            }, function() {
                if (mine === requestId) {
                    $scope.isCountAvailable = false;
                }
            });
        };

        // a new day (date box, arrows, Back) loads its appointments
        $scope.$watch('dateInput', function(newDate) {
            if (newDate) {
                $scope.getAppointmentsForAgents();
            }
        });
    });
